import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="text-center max-w-md">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-ih-neon mb-4">Error 404</p>
        <h1 className="font-display font-black text-7xl text-white mb-4">Off the map.</h1>
        <p className="text-white/60 mb-8">
          This route doesn&apos;t exist on the IslandHop network. Let&apos;s get you back.
        </p>
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-black font-semibold hover:scale-[1.02] transition" data-testid="notfound-home-link">
          Back to home
        </Link>
      </div>
    </div>
  );
}
